import './fonts.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ReadOnlySlatePage from './components/SlateEditor/ReadOnlySlate';
import Login from "./components/Login/Login";
import Dashboard from "./components/Dashboard";
import Editor from './components/SlateEditor/Editor';
import AdminOptions from './components/AdminOptions';
import ImgPage from './components/ImgPage';
import RegisterPage from './components/Register/RegisterPage_test';
import RedirectEditPage from './components/RedirectEditPage';
import DynamicPage from './components/DynamicPage';
import ResetPassword from "./components/Login/ResetPassword";
import AddQRCode from './components/AddQRCode';
import { AuthProvider } from "./components/AuthContext";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';



function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/admin/:link" element={<AdminOptions />} />
          <Route path="/admin/text/:link" element={<Editor />} />
          <Route path="/admin/img/:link" element={<ImgPage />} />
          <Route path="/admin/url/:link" element={<RedirectEditPage />} />
          <Route path="/:link" element={<DynamicPage />} />
          <Route path="/slate/:userId" element={<ReadOnlySlatePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="/add-qr-code" element={<AddQRCode />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
